module.exports = __webpack_public_path__ + "static/media/logo.7baf5b09.jpg";